import vue from 'vue'
import vuex from 'vuex'
import storeBackendSetting from '@/store/modules/storeBackendSetting.js'
import storeI18n from '@/store/modules/storeI18n.js'
import storeMemberInfo from '@/store/modules/storeMemberInfo.js'

vue.use(vuex);


export default new vuex.Store({
    modules: {
        storeBackendSetting: storeBackendSetting,
        storeI18n: storeI18n,
        storeMemberInfo: storeMemberInfo,
    },
    strict: true // 嚴格模式，禁止直接修改 state
})